import { Button, Dialog, DialogActions, DialogTitle, ValidatorForm, makeStyles, Slide, CSSProperties } from 'MaterialUIComponents';
import { TransitionProps } from '@mui/material/transitions/transition';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { React } from 'Imports';
import { useRef, useState } from 'react';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="left" ref={ref} {...props} mountOnEnter unmountOnExit timeout={500} />;
});

interface ISliderDialogProps {
    title: string;
    open: boolean;
    onClose: () => void;
    submitButtonText?: string;
    cancelButtonText?: string;
    children?: any;
    submitButtonDisabled?: boolean;
    onSubmit: any;
    isEncompass: boolean;
    isRunningStandAlone: boolean;
    widthFitContent?: boolean;
    headerClassName?: string;
    footerClassName?: string;
    paperClassName?: string;
    submitButtonClassName?: string;
    cancelButtonClassName?: string;
    buttonsContainerClassName?: string;
    contentWrapperClassName?: string;
    onBack?: () => void;
    backButtonText?: string;
    backButtonClassName?: string;
}

type SliderDialogProps = ISliderDialogProps;

const useStyles = makeStyles({
    customScrollPaper: {
        alignItems: 'stretch',
        justifyContent: 'flex-end',
    },
    customPaper: {
        margin: 0,
        borderRadius: 0,
    },
    customMaxHeight: {
        maxHeight: '100%',
    },
    customActionButtons: {
        boxShadow: '10px 10px 10px 10px grey !important',
        marginTop: 'auto',
    },
    customActionButtonsPadding: {
        boxShadow: '10px 10px 10px 10px grey !important',
        marginTop: 'auto',
        padding: '14px 24px !important',
    },
    customActionButtonsBase: {
        marginTop: 'auto',
    },
    customTitle: {
        fontWeight: 'bold',
        boxShadow: '0px 0px 10px 0px grey !important',
    },
    customTitleBase: {
        fontWeight: 'bold',
    },
    customWidthXs: {
        maxWidth: '355px',
    },
    customWidthXsFitContent: {
        maxWidth: 'fit-content',
    },
});

const styles = require('./SliderDialog.scss') as {
    cancelButton: string;
    saveButton: string;
    saveButtonNewStyle: string;
    dialogActions: string;
    genericForm: string;
    closeIcon: string;
    dialogTitleRootIntegrated: string;
    dialogTitleRoot: string;
    dialogTitleRootSmallFontSize: string;
};

const SliderDialog = ({
    title,
    open,
    onClose,
    children,
    submitButtonText,
    cancelButtonText,
    submitButtonDisabled,
    onSubmit,
    isEncompass,
    isRunningStandAlone,
    widthFitContent,
    headerClassName,
    footerClassName,
    paperClassName,
    submitButtonClassName,
    cancelButtonClassName,
    buttonsContainerClassName,
    contentWrapperClassName,
    onBack,
    backButtonText,
    backButtonClassName,
}: SliderDialogProps) => {
    const classes = useStyles();
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (event: any) => {
        setIsSubmitting(true);
        try {
            await onSubmit(event);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        setIsSubmitting(false);
        onClose();
    };

    return (
        <>
            <Dialog
                open={open}
                maxWidth="xs"
                fullWidth={true}
                scroll="paper"
                classes={{
                    scrollPaper: classes.customScrollPaper,
                    paper: classes.customPaper,
                    paperScrollPaper: classes.customMaxHeight,
                    paperWidthXs: widthFitContent ? classes.customWidthXsFitContent : classes.customWidthXs,
                }}
                PaperProps={paperClassName ? { className: paperClassName } : undefined}
                TransitionComponent={Transition}
            >
                <ValidatorForm ref={formRef} onSubmit={handleSubmit} className={styles.genericForm}>
                    <DialogTitle
                        className={headerClassName}
                        classes={{
                            root: headerClassName ? classes.customTitleBase : classes.customTitle,
                        }}
                    >
                        <div
                            className={
                                !isEncompass && !isRunningStandAlone
                                    ? styles.dialogTitleRootIntegrated
                                    : widthFitContent
                                      ? styles.dialogTitleRootSmallFontSize
                                      : styles.dialogTitleRoot
                            }
                        >
                            <strong>{title}</strong>
                            <span className={styles.closeIcon}>
                                <FontAwesomeIcon icon={faTimes} onClick={handleClose} />
                            </span>
                        </div>
                    </DialogTitle>
                    <div className={contentWrapperClassName ?? ''}>{children}</div>
                    <DialogActions
                        className={footerClassName ?? ''}
                        classes={{
                            root: footerClassName
                                ? classes.customActionButtonsBase
                                : widthFitContent
                                  ? classes.customActionButtonsPadding
                                  : classes.customActionButtons,
                        }}
                    >
                        <div className={buttonsContainerClassName || styles.dialogActions}>
                            <Button onClick={handleClose} className={cancelButtonClassName || styles.cancelButton} disabled={isSubmitting}>
                                {cancelButtonText || 'Cancel'}
                            </Button>
                            {onBack && (
                                <Button
                                    type="button"
                                    onClick={onBack}
                                    className={backButtonClassName || styles.cancelButton}
                                    disabled={isSubmitting}
                                >
                                    {backButtonText || 'Back'}
                                </Button>
                            )}
                            <Button
                                disabled={submitButtonDisabled || isSubmitting}
                                className={submitButtonClassName || (widthFitContent ? styles.saveButtonNewStyle : styles.saveButton)}
                                type="submit"
                            >
                                {submitButtonText || 'Save'}
                            </Button>
                        </div>
                    </DialogActions>
                </ValidatorForm>
            </Dialog>
        </>
    );
};

export default SliderDialog;
